import { Component, OnInit, Output, Input, EventEmitter, ChangeDetectorRef, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';


@Component({
  selector: 'mf-column-selector',
  templateUrl: './mf-column-selector.component.html',
  styleUrls: ['./mf-column-selector.component.css']
})
export class MfColumnSelectorComponent implements OnInit {
  _loading: boolean = false;
  selectableSettings: any = {
    mode: 'multiple',
    checkboxOnly: true
  }
  @Input()
  set loading(value) {
    this._loading = value;
    this.loadingChange.emit(this._loading);
  }
  get loading() {
    return this._loading;
  }
  @Input()
  set selectedColumns(value) {
    this._selectedColumns = value;
    this._selectedColumnFields = this._selectedColumns.map(item => {
      return item.field
    });
    this.selectedColumnsChange.emit(this._selectedColumns);
  }
  get selectedColumns() {
    var selectedCols = new Array();
    this._selectedColumnFields.forEach(o => {
      var filt = this.staticColumns.filter(function (i) {
        return i.field == o;
      });
      selectedCols.push(filt[0]);
    })
    return selectedCols;
  }
  _selectedColumnFields: any = new Array();
  set selectedColumnFields(value) {
    this._selectedColumnFields = value;
  }
  get selectedColumnFields() {
    return this._selectedColumnFields
  }

  _columns: any[];
  get columns() {
    return this._columns;
  }
  @Input() set columns(value) {
    this._columns = value.filter(o => typeof (o.visible) == 'undefined' || o.visible).map(item => {
      return { label: item.name, value: item.field }
    });
  }
  public colTest: any = new Array;
  _selectedColumns: any[];
  @Input() staticColumns: any[];
  @Output() selectedColumnsChange = new EventEmitter();
  @Output() columnsChange = new EventEmitter();
  @Output() loadingChange = new EventEmitter();

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private ref: MatDialogRef<MfColumnSelectorComponent>) {
    this.columns = data.columns;
    this.selectedColumns = data.selectedColumns;
    this.staticColumns = data.staticColumns;
    // this.colTest = config.data.columns;
    //this.cdr.detectChanges();
  }

  ngOnInit() {
  }

  public done() {
    this.ref.close(this.selectedColumns);
  }

}
